module.exports = __webpack_public_path__ + "static/img/bighaibao3.fe6819b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/bighaibao3.png
// module id = ULNX
// module chunks = 0